import { Badge } from '@/components/ui/badge';

export const ExpenseItemsTable = ({ items = [], testIdPrefix = 'expense-items-table' }) => {
  if (!items.length) {
    return null;
  }

  return (
    <div className="rounded-2xl border border-slate-200 bg-white" data-testid={testIdPrefix}>
      <div className="flex items-center justify-between border-b border-slate-200 px-4 py-3">
        <div>
          <p className="text-sm font-semibold text-slate-950">Artigos do documento</p>
          <p className="text-xs text-muted-foreground">Resumo por linha lançada nesta despesa.</p>
        </div>
        <Badge variant="outline" data-testid={`${testIdPrefix}-count-badge`}>{items.length} linhas</Badge>
      </div>

      <div className="overflow-x-auto">
        <table className="min-w-full text-sm">
          <thead className="bg-slate-50 text-left text-xs uppercase tracking-wide text-slate-500">
            <tr>
              <th className="px-4 py-2">Artigo</th>
              <th className="px-4 py-2">Qtd</th>
              <th className="px-4 py-2">Aplicada</th>
              <th className="px-4 py-2">Saldo</th>
              <th className="px-4 py-2">Unit.</th>
              <th className="px-4 py-2 text-right">Total</th>
            </tr>
          </thead>
          <tbody>
            {items.map((item, index) => (
              <tr key={item.id || index} className="border-t border-slate-100" data-testid={`${testIdPrefix}-row-${index}`}>
                <td className="px-4 py-3 font-medium text-slate-900">{item.description}</td>
                <td className="px-4 py-3 text-slate-600">{item.quantity} {item.unit}</td>
                <td className="px-4 py-3 text-slate-600">{item.used_quantity} {item.unit}</td>
                <td className="px-4 py-3 text-slate-600">{item.remaining_quantity} {item.unit}</td>
                <td className="px-4 py-3 text-slate-600">{item.unit_price} MTn</td>
                <td className="px-4 py-3 text-right font-semibold text-emerald-700">{item.total} MTn</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};